import { render, staticRenderFns } from "./trailer.vue?vue&type=template&id=05497bd2&scoped=true"
import script from "./trailer.vue?vue&type=script&lang=js"
export * from "./trailer.vue?vue&type=script&lang=js"
import style0 from "./trailer.vue?vue&type=style&index=0&id=05497bd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05497bd2",
  null
  
)

export default component.exports